import React, { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";

export const Faq = ({ data: { question, answer } }) => {
  const [showAccordion, setShowAccordion] = useState(false);
  return (
    <div
      onClick={() => setShowAccordion(!showAccordion)}
      className="border p-4  rounded-xl w-full  my-3 cursor-pointer text-left dark:border-[#5B5B5B]"
    >
      <div className="flex items-center justify-between">
        <h1 className="text-lg w-80 lg:w-full font-[500] lg:text-[20px]">{question}</h1>
        {showAccordion ? <FiMinus className="transition-all duration-300 ease-in-out"/> : <FiPlus className="transition-all duration-300 ease-in-out" />}
      </div>
      <div className={`grid overflow-hidden transition-all duration-300 ease-in-out ${showAccordion ? "grid-row-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
        <p className=" text-lg font-[400] text-gray-500 overflow-hidden dark:text-white">
          {answer}
        </p>
      </div>
    </div>
  );
};
